
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface NursingHomeMediaProps {
  centerName: string;
  nhSlug: string;
  imageUrl?: string;
}

export function NursingHomeMedia({ centerName, nhSlug, imageUrl }: NursingHomeMediaProps) {
  // Handle image URLs properly
  const getImageUrl = () => {
    // If the URL is already a full URL (including http or https), return it directly
    if (imageUrl && (imageUrl.startsWith('http://') || imageUrl.startsWith('https://'))) {
      return imageUrl;
    }
    
    // If we have a local URL but it doesn't start with a slash, add one
    if (imageUrl && !imageUrl.startsWith('/')) {
      return `/${imageUrl}`;
    }
    
    // Return the local URL as is if it has a leading slash
    if (imageUrl) {
      return imageUrl;
    }
    
    // Use unsplash fallback with nhSlug as query
    const placeholderUrl = `https://source.unsplash.com/featured/?nursing,home,elderly,${nhSlug}-1`;
    return placeholderUrl;
  };
  
  // Use the processed image URL
  const displayUrl = getImageUrl();
  
  console.log(`NursingHomeMedia - Center: ${centerName}, Original URL: ${imageUrl}, Display URL: ${displayUrl}`);

  return (
    <div className="bg-white py-6 border-b">
      <div className="container">
        <div className="w-full max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-lg">
            <AspectRatio ratio={16/9}>
              <img 
                src={displayUrl} 
                alt={`${centerName}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  console.error(`Error loading image for ${centerName}: ${displayUrl}`);
                  (e.target as HTMLImageElement).src = "https://via.placeholder.com/800x450?text=Nursing+Home";
                }}
              />
            </AspectRatio>
          </div>
        </div>
      </div>
    </div>
  );
}
